const uniform = (min: number, max: number) => {
  return min + (max - min) * Math.random();
};

const uniformDiscrete = (i: number, j: number) => {
  return i + Math.floor((j - i + 1) * uniform(0, 1));
};

export { uniformDiscrete };



// WEBPACK FOOTER //
// ./src/publics/assets/js/random.ts